import { MsalProvider } from '@azure/msal-react';
import AuthContextProvider from 'features/Auth/contexts/AuthContextProvider';
import { getRedirectUri, msalInitPromise, pca } from 'features/Auth/contexts/utils/authUtils';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { store } from './store';
import './theme.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  console.warn = () => {};
  console.error = () => {};
  console.trace = () => {};
}

// Ensure ports are used instead of redirecting to devdemo
getRedirectUri();

// Wait for MSAL initialization before rendering the app
// This ensures handleRedirectPromise completes before React renders
msalInitPromise
  .then(() => {
    root.render(
      <Provider store={store}>
        <AuthContextProvider>
          <MsalProvider instance={pca}>
            <App />
          </MsalProvider>
        </AuthContextProvider>
      </Provider>,
    );
  })
  .catch((error) => {
    console.error('Failed to initialize MSAL:', error);
    // Render anyway so the app isn't blank, but MS login won't work
    root.render(
      <Provider store={store}>
        <AuthContextProvider>
          <MsalProvider instance={pca}>
            <App />
          </MsalProvider>
        </AuthContextProvider>
      </Provider>,
    );
  });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

/*                            ███████████████
//                           ██▓▒░░░░░░░▒▒▒▓█
//                          ██▓▒░░░░░░░░▒▒▓██
//     ███████████████    ███▒░░░░░░░░░▒▒███
//     ██▒▒▒▒▒▒▒▒▒▒▒▒██  ██▓▒░░░░░░░░░▒▒██
//     ██▓▒▒░░░░░░░░▒▒▓███▓▒░░░░░░░░▒▒▓██
//       ██▒▒░░░░░░░░░▒▓█▒▒░░░░░░░░▒▒▓██
//        ██▓▒░░░░░░░░░▒▒▒░░░░░░░▒▒▒██
//         ██▓▒▒░░░░░░░░░░░░░░░░▒▒▓██
//           ██▒▒░░░░░░░░░░░░░░▒▒▓██
//            ██▓▒▒▒░░░░░░░░░▒▒▒████████████████████████
//             ██▓▒▒▒▒▒▒▒▒▒▒▒▒▓████▒▒░░░░░░░░░░░░░░░▒▒▓▓███
//             ██▓▒▒▒▒▒▒▒▒▒▒▒▒▒███▓▒░░░░░░░░░░░░░░░░░░░░▒▒▓██
//            ██▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▓█▓▒░░░░░░░░░░░░░░░░░░░░░░▒▒▓██
//           █▓▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▓▓▒▒░░░░░░░░░░░░░░░░░░░░░░▒▒▓██
//         ██▓▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒░░░░░▒▒▒▒██
//        ██▓▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▓███████████████▓▒▒▒▒▒▒▒▒▒▒▓██
//      ██▓▒▒▒▒▒▒▒▒▒▒▒▒██▓▒▒▒▒▒▒▒▒▒▒▒▓██            ██▓▒▒▒▒▒▒▒▒▒██
//     ██▓▒▒▒▒▒▒▒▒▒▒▒▓████▓▒░░░░░▒▒░░░▒▒▒░░░        ██▓▒▒▒▒▒▒▒▒▒██
//    ██▓▒▒▒▒▒▒▒▒▒▒▒▓██   ▓▒░░░░▒▓▓▓▓███████████████▓▒▒▒▒▒▒▒▒▒▒▒██
//  ██▓▒▒▒▒▒▒▒▒▒▒▒▒██      ░░░░░ █▓▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▓██
// ██▓▒▒▒▒▒▒▒▒▒▒▒▓██             █▓▒▒░░▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▓██
// ██▒▒▒▒▒▒▒▒▒▒▒▓██              █▓▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▓██
//  █████████████                █▓▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▓██
//                               █▓▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▓▓▓███
//                               █▓▒▒▒▒▒▒▒▒▒▒▓███████████
//                               █▓▒▒▒▒▒▒▒▒▒▒▓█
//                               █▓▒▒▒▒▒▒▒▒▒▒▓█
//                               █▓▒▒▒▒▒▒▒▒▒▒▓█
//                               █▓▒▒▒▒▒▒▒▒▒▒▓█
//                               █▓▒▒▒▒▒▒▒▒▒▒▓█
//                               █▓▒▒▒▒▒▒▒▒▒▒▓█
//                               ██▒▒▒▒▒▒▒▒▒▒▓█
                                  ██▓▓▓▓▓▓▓▓███
*/

/*                                              
                                                █▒▒█                                                
                                               ▓█░░█▒                                               
                                          ██░░░░░░░░░░▒▒██                                         
                                            ██░░░░░░░▒█▓                                        
                                             ▒█░░░░░▒█                                         
                                             █▒░░▓▓░░█▓                                             
                                            ░█▓█▓▒▒▓███                                             
                                           ▒█▒▒▒▒▒▒▒▒▒██                                            
                                          ░█▓▒▒▒▒▒▒▒ ▒▒██                                           
                                         ░█▓▒▒▒▒▒▒▒▒▒▒▒▒██                                          
                                         █▒▒▒▒░░▒▒▒▒▒▒▒▒▒██                                         
                                       ░█▓▒▒▒▒▒▒▒▒▒▒▒██▒▒▒██                                        
                                      ░█▒▒▓▒▒▒▒▒▒▒▒▒▒▓█▒▒▒▒██                                       
                                     ▒█▒▓▒ ░▓▒▒▒▒▒▒█▓▒▓▓█▒▒▒▓█                                      
                                    ▒█▒▒█░░░▒▓▒▒▒▒▓▓▒▒▓▓▓█▒▒▒▓█                                     
                                   ▓█▒▒▒▒▓▓▓▓▒▒▒▒▒▒█▓▓▓▓█▓▒ ░▒▓█▒                                   
                                  ██▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▓▓▒▒▒▒▒▒▒▒▓█▓                                  
                                 ██▒▒▒▒▒▓▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒██▓▒▒▓██                                 
                               ░█▓▓████▓█▓▒▒▒███▒▒▒▒▓██▒▒▒▒█▓███████                                
                                ░░▒█▓▒▒▒▓█▓██▓▒██▒▒██▓▓█████▒▒▒▓█░░░                                
                                 ░█▒▒▒▒▒▒▒▒▒▒▒▒▒▒▓█▓▒▒▒▒▒▒▒▒▒▒▒▒▓█                              
                                ░█▒▒▒░ ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▓█                                 
                               ▓█▒▒▒▓▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒░░▒▒▒▒▒▒▒▒▒▓█▒                               
                              ▓█▒▒▒▓██▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▓▒▒▒▒▒▒▒▒▓█▒                              
                             ██▒▒▓▓▒▒▓▓▓▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒██▓▒▒▒▒▒▒▒▓██                             
                            █▓▒▒▒▓▓▓▓▓▓▓▒▒▒░░▒▒▒▒▒▒▒▒▒▒▒█░░░░█▒▒▒▒▒▒▒▒██                            
                           █▓▒░░▒▒▓███▓▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒█░░░░▒▓▒▒▒▒▒░ ▒██                           
                         ░█▓▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒█▓▒█▓▒▒▒▒▒▒▒▒▒▒██░                         
                        ░█▒▒▒▒▒▓███▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▓▒▒▒▒▒▒▓█▒▒▒▒▒▒███▓▓▓▒▒▓█▒                        
                       ▒███████▓▒▓█▒▒▒▒▒███▒▒▒▒▒▒███▒▒▒▒▒█▓██▒▒▒▓█▒▒██▓██████                       
                            ░█▒▒▒▒▓████▓▒▒▓█▒▒▒▒█▓▒▒██▓▓█▓▒▒▒████▒▒▒▒██                      
                           ▒█▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒███▓▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▓█░                           
                          ▓█▒▒▒▒▓█▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒  ▒▒▒▒▒▒▒▒▒▒▒▓█▒                          
                         ██▒▒▒▒▒▓▓▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒█▓▒▓██                         
                        █▓▒▒▒▒█▒▒▓█▓▒▒▒▒▒ ▒▒▒▒▒▒▓▓▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▓█▒░░▓█▓██                        
                      ░█▒▒▒▒▒█▒▓▓▓▓█▒▒▒▒▒▒▒▒▒▒▓▓▒▓█▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▓▒░░░░█▓▓██                       
                     ██▒▒▒▒▒▒▓█▓▓▓▓█▒▒▒▒▒▒▒▒▒▓▒░░░▒▓▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒██░░██▓▒▓▓█▓                     
                    ██▒▒░░▒▒▒▒▒▓█▓▓▒▒▒▒▒▒▒▒▒▒▒█▒▒▓█▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▓▓▓▓▓▓▓▒░▒▓██                    
                   █▓▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▓▓▒▓▓▓▓▓▓▓▓▒▓▓▓██                   
                 ▒█▓▒▒▒▒▒▒▒▓███▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▓▒▒▒▒▒▒▒▒▒▒▒▓▒▓▓▓▓▓███▓▓▓▓▓▓▓▓▓█▒                 
                 ███████▒░   ▒█▒▒▒▒▒▒▒███▓▒▒▒▒▒▓█████▒▒▒▒▒████▓▓▓▓▓▓▓██   ░▒▓██████                 
                             ██▓█████▒   █▓▒▒██████████▓▓██   ░▓████▓██              
                                          ██████▓▓███████▓                               
                                             ██▓▓▓▓████                        
                                             ██▓▓▓▓▓███                                             
                                             █▓▓▓▓▓▓███                                             
                                             ██████████                                            
                                                         
*/
